import API from "@core/api/api";

export const ticketService = {
  // Create a new ticket
  createTicket: async (ticketData) => {
    const formData = new FormData();
    
    // Add text fields
    Object.keys(ticketData).forEach(key => {
      if (key !== 'attachments' && ticketData[key] !== undefined && ticketData[key] !== null) {
        formData.append(key, ticketData[key]);
      }
    });
    
    // Add file attachments
    if (ticketData.attachments && ticketData.attachments.length > 0) {
      ticketData.attachments.forEach((file) => {
        formData.append('attachments', file);
      });
    }
    
    const response = await API.post("/tickets", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  // Get all tickets (admin/manager) or filtered tickets
  getAllTickets: async (params = {}) => {
    const response = await API.get("/tickets", { params });
    return response.data;
  },

  // Get my tickets (client/livreur)
  getMyTickets: async (params = {}) => {
    const response = await API.get("/tickets/my-tickets", { params });
    return response.data;
  },

  // Get ticket by ID
  getTicketById: async (id) => {
    const response = await API.get(`/tickets/${id}`);
    return response.data;
  },

  // Get ticket by ticket number
  getTicketByNumber: async (ticketNumber) => {
    const response = await API.get(`/tickets/number/${ticketNumber}`);
    return response.data;
  },

  // Add message to ticket
  addMessage: async (ticketId, messageData) => {
    const formData = new FormData();
    
    // Add message text
    if (messageData.message) {
      formData.append('message', messageData.message);
    }
    
    if (messageData.isInternal !== undefined) {
      formData.append('isInternal', messageData.isInternal);
    }
    
    // Add file attachments
    if (messageData.attachments && messageData.attachments.length > 0) {
      messageData.attachments.forEach((file) => {
        formData.append('attachments', file);
      });
    }
    
    const response = await API.post(`/tickets/${ticketId}/messages`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  // Update ticket (admin/manager only)
  updateTicket: async (id, updateData) => {
    const response = await API.put(`/tickets/${id}`, updateData);
    return response.data;
  },

  // Assign ticket (admin/manager only)
  assignTicket: async (id, assigneeId) => {
    const response = await API.put(`/tickets/${id}/assign`, { assigneeId });
    return response.data;
  },

  // Resolve ticket (admin/manager only)
  resolveTicket: async (id, resolution) => {
    const response = await API.put(`/tickets/${id}/resolve`, { resolution });
    return response.data;
  },

  // Close ticket (admin/manager only)
  closeTicket: async (id, reason = null) => {
    const response = await API.put(`/tickets/${id}/close`, { reason });
    return response.data;
  },

  // Reopen ticket (admin/manager only)
  reopenTicket: async (id) => {
    const response = await API.put(`/tickets/${id}/reopen`);
    return response.data;
  },

  // Get ticket statistics (admin/manager only)
  getTicketStatistics: async (params = {}) => {
    const response = await API.get("/tickets/statistics", { params });
    return response.data;
  },

  // Download attachment
  downloadAttachment: async (ticketId, messageId, attachmentIndex) => {
    const response = await API.get(
      `/tickets/${ticketId}/messages/${messageId}/attachments/${attachmentIndex}/download`,
      { responseType: 'blob' }
    );
    return response;
  },

  // Add customer feedback
  addCustomerFeedback: async (id, rating, feedback = null) => {
    const response = await API.post(`/tickets/${id}/feedback`, { 
      rating, 
      feedback 
    });
    return response.data;
  }
};